var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-resize-observer",
    { on: { resize: _vm.handleContainerResize } },
    [
      _c(
        "simplebar",
        {
          ref: "simplebar",
          staticClass: "base-virtual-scroll",
          on: { scroll: _vm.handleScroll },
        },
        [
          _c("base-virtual-scroll-viewport", {
            attrs: {
              items: _vm.items,
              "active-item-id": _vm.activeItemId,
              context: _vm.context,
              "data-key": _vm.dataKey,
              "offset-top": _vm.offsetTop,
              "offset-bottom": _vm.offsetBottom,
              "visible-items": _vm.visibleItems,
              "scroll-top-diff": _vm.scrollTopDiff,
              "item-sizes-by-id": _vm.itemSizesById,
              "default-item-size": _vm.defaultItemSize,
              "is-scrolling": _vm.isScrolling,
            },
            on: {
              "item-activation": _vm.handleItemActivation,
              "item-deactivation": _vm.handleItemDeactivation,
              "item-resize": _vm.handleItemResize,
              "header-slot-resize": _vm.handleHeaderSlotResize,
              "footer-slot-resize": _vm.handleFooterSlotResize,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (props) {
                    return [_vm._t("default", null, null, props)]
                  },
                },
                {
                  key: "header",
                  fn: function () {
                    return [_vm._t("header")]
                  },
                  proxy: true,
                },
                {
                  key: "footer",
                  fn: function () {
                    return [_vm._t("footer")]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }